import { combineReducers } from 'redux';
import defaultReducer from './default/reducer';
import custom from './custom/reducer';

export default combineReducers({
  default: defaultReducer,
  custom,
});
